import { render, staticRenderFns } from "./EnableFeatureForm.vue?vue&type=template&id=168fdac6&"
import script from "./EnableFeatureForm.vue?vue&type=script&lang=js&"
export * from "./EnableFeatureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports